import { Box } from '@mui/material';
import CreateActivityContainer from '../CreateActivityContainer/CreateActivityContainer';

function ActivitiesContainer() {
  return (
    <Box height="100%" width="100%" mt={3}>
      <CreateActivityContainer initialStep={0} />
    </Box>
  );
}

export default ActivitiesContainer;
